import React from 'react';

const Footer = () => {
    return (
            <>
            <div className='py-3 text-center bg-info text-white mt-4'>
                <h4>Footer 2021</h4>
            </div>
        </>
        );

};

export default Footer;
